export default {
  /////////////////
  // COMPANY OBJECTS
  /////////////////

  // SET_COMPANY_OBJECTS(state, objects) {
  //   state.objects = objects
  // },
  // ADD_COMPANY_OBJECTS(state, objects) {
  //   state.objects.push(objects)
  // },
  // EDIT_COMPANY_OBJECTS(state, value) {
  //   const userIndex = state.objects.findIndex((u) => u.id === value.id)
  //   state.objects.splice(userIndex, 1, value)
  // },
  SET_ONLINE_CO2_STATS(state, payload) {
    state.onlineCo2Stats = payload;
  },
};
